type EnableWorkflowWarningProps = {
  isBulk: boolean;
};

export const EnableWorkflowWarning = ({ isBulk }: EnableWorkflowWarningProps) => (
  <p>
    Once {isBulk ? 'a' : 'this'} journey is enabled, contacts can begin to enter and trigger any
    connected campaigns.
  </p>
);
